import { combineReducers } from 'redux'
import { reducers } from '@adc/ui-morpheus'
import { ORGANIZATION_MEMBERS } from '../../constants/tableTypes'
import tableReducer from './columnDefinitions'

const initialState = {
  content: [],
  total_elements: 0,
}

const organizationMembersReducers = (state = initialState, action) => {
  switch (action.type) {
    default:
      return reducers.dataTable.tableFetchReducer(
        ORGANIZATION_MEMBERS,
        state,
        action
      )
  }
}

export default combineReducers({
  data: organizationMembersReducers,
  tableInfo: tableReducer,
})

export { initialState, organizationMembersReducers }
